import {
    FaShieldHeart,
    FaMicrochip,
    FaCouch,
    FaSliders,
    FaWrench,
    FaUserDoctor,
    FaFileInvoiceDollar,
    FaHeadset,
    FaMoneyBillTrendUp,
    FaMoneyBillWave,
    FaPuzzlePiece,
    FaStethoscope,
    FaClock,
} from "react-icons/fa6";

export const stepper = [
    {
        icon: <FaShieldHeart />,
        title: "Non-Invasive & Drug-Free",
        description:
            "TMS therapy is a safe, proven mental health treatment. It doesn't need medications or surgery.",
        align: "bottom",
    },
    {
        icon: <FaMicrochip />,
        title: "Advanced Technology",
        description:
            "Our system includes state-of-the-art figure-8 stimulation coils, ensuring precise, effective therapy for patients.",
        align: "top",
    },
    {
        icon: <FaCouch />,
        title: "Enhanced Patient Comfort",
        description:
            "Ergonomic designs, like head stabilization and neck support, increase patient comfort during treatment.",
        align: "bottom",
        featured: true,
    },
    {
        icon: <FaSliders />,
        title: "Custom Protocols",
        description:
            "FDA-approved, pre-installed treatment protocols ease sessions and maximize clinical efficiency.",
        align: "top",
    },
];

export const collectionSteps = [
    {
        id: 1,
        number: "01",
        icon: <FaWrench />,
        title: "Equipment & Setup",
        description:
            "We provide advanced TMS equipment and prepare everything for immediate treatment.",
    },
    {
        id: 2,
        number: "02",
        icon: <FaUserDoctor />,
        title: "Trained Staff",
        description:
            "Our program includes trained technicians, eliminating the need for additional hiring or training.",
    },
    {
        id: 3,
        number: "03",
        icon: <FaFileInvoiceDollar />,
        title: "Billing Made Easy",
        description:
            "Billing is handled under your NPI, with reimbursements sent directly to your account.",
    },
    {
        id: 4,
        number: "04",
        icon: <FaHeadset />,
        title: "Ongoing Support",
        description:
            "We manage equipment, supplies, and troubleshooting so you can focus on patient care.",
    },
];

export const benefitsData = [
    {
        title: "Generate New Revenue",
        description:
            "Our program creates a new income source for your practice. It lets you collect reimbursements directly through your NPI.",
        icon: FaMoneyBillTrendUp,
    },
    {
        title: "No Initial Expense",
        description:
            "MITSI provides everything you need for a per-session fee. It includes equipment, trained techs, and billing support.",
        icon: FaMoneyBillWave,
    },
    {
        title: "Covered by Insurance",
        description:
            "Most private insurers, Medicare, and Medicaid cover TMS therapy. So, it is accessible to many patients.",
        icon: FaShieldHeart,
    },
    {
        title: "Smooth Incorporation",
        description:
            "We offer a ready-to-use setup with trained staff. You can start TMS services without disrupting your workflow.",
        icon: FaPuzzlePiece,
    },
    {
        title: "Matching Treatment",
        description:
            "TMS works well with other therapies and medications. It offers a holistic approach to patient care.",
        icon: FaStethoscope,
    },
    {
        title: "Patient-Centered Care",
        description:
            "TMS provides a personalized treatment approach designed around each patient's individual needs.",
        icon: FaUserDoctor,
    },
    {
        title: "Flexible Treatment Sessions",
        description:
            "Convenient TMS sessions can fit smoothly into your practice workflow and patient schedules.",
        icon: FaClock,
    },
    {
        title: "Clinical Support",
        description:
            "Our team provides ongoing guidance to help your practice deliver TMS treatments with confidence.",
        icon: FaHeadset,
    },
];